// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MonthlyChart_wrapper__2ad6W","headerRow":"MonthlyChart_headerRow__16gmO"};